import { createContext, useContext } from "react";
import type { ILandingRootStore } from "./landing-root.store";

export const LandingStoreContext = createContext<ILandingRootStore | null>(
  null,
);

export const useLandingStore = (): ILandingRootStore => {
  const store = useContext(LandingStoreContext);

  if (!store) {
    throw new Error(
      "useLandingStore must be used within LandingStoreProvider. " +
        "Ensure that LandingStoreProvider wraps your component tree.",
    );
  }

  return store;
};
